import React from "react";

import ViewDropdown from "../../common/component/ViewDropdown";
import { UNIT_GROUPING } from "../../constants/types";
import useAuth from "../../routes/login/AuthContext";
import { setUnitGrouping } from "../../services/IntegrationApi";

import type { IProps } from "./types";

const OPTIONS = [
  { name: "UNIT_ID", id: UNIT_GROUPING.UNIT_ID },
  { name: "UNIT_SPACE_NUMBER", id: UNIT_GROUPING.UNIT_SPACE_NUMBER },
];

export const UnitGroupingSelector: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const [value, setValue] = React.useState(props.defaultValue || UNIT_GROUPING.UNIT_ID);

  const handleChange = async (selectedValue: UNIT_GROUPING) => {
    setValue(selectedValue);
    setUnitGrouping(
      props.userId,
      props.row.propertyId,
      {
        unitGrouping: selectedValue,
        enabled: props.row.enabled,
        importApplicants: props.row.importApplicants,
        importSignedApplicants: props.row.importSignedApplicants,
        signedApplicationEventType: props.row.signedApplicationEventType,
        l1Id: props.row.l1Id,
        propertyName: props.row.propertyName,
        importFullRooms: props.row.importFullRooms,
        notifyFullRooms: props.row.notifyFullRooms,
        importMonthToMonth: props.row.importMonthToMonth,
      },
      await getAuthToken()
    )
      .then(() => props.onChange(selectedValue))
      .catch(() => props.handleError(true));
  };

  const handleClick = (e: Event) => e.stopPropagation();

  return <ViewDropdown width="100%" title={value} options={OPTIONS} onClick={handleClick} handler={handleChange} />;
};
